import React from 'react';
import { IconProps } from 'types';

const Logo = ({ className }: IconProps) => {
  return (
    <svg
      className={className}
      width="450"
      height="70"
      viewBox="0 0 668.9 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <style>{`.st0{fill:#06374E;}
	.st1{enable-background:new;}`}</style>
      </defs>
      <polygon
        className="st0"
        points="658.6,14.9 658.6,16.1 658.6,17.3 658.6,18.2 658.6,18.2 "
      />
      <polygon
        className="st0"
        points="658.6,18.2 658.6,18.2 658.6,21.7 658.6,21.7 "
      />
      <polygon
        className="st0"
        points="658.6,11.2 658.6,14.9 658.6,14.9 658.6,14.9 "
      />
      <path
        className="st0"
        d="M658.6,18.2L658.6,18.2v-1l0,0V18.2z M658.6,16.1v1.2V16.1z M658.6,16.1L658.6,16.1V15l0,0V16.1z"
      />
      <rect x="658.6" y="14.9" className="st0" width="0" height="1.1" />
      <rect x="658.6" y="17.3" className="st0" width="0" height="1" />
      <polygon
        className="st0"
        points="664.2,15.6 664.9,15 665.6,15.5 665.4,14.7 666.1,14.1 665.2,14.1 664.9,13.3 664.6,14.1 663.7,14.1 
	664.4,14.7 "
      />
      <path
        className="st0"
        d="M668.9,13.1v-2.6h-0.7V9.4h-19.1v1.1h-0.7v2.6h0.7v4.3h-0.7V20h0.7v1.8l3.7,2.9l-0.4,0.6l2.1,1.6l0.4-0.6
	l3.7,2.9l0,0l0,0l3.8-2.9l0.4,0.6l2.1-1.6l-0.4-0.6l3.7-2.8V20h0.7v-2.6h-0.7V13L668.9,13.1L668.9,13.1z M651.5,15.6l0.3-0.9
	l-0.7-0.6h0.9l0.3-0.8l0.3,0.8h0.9l-0.7,0.6l0.3,0.9l-0.7-0.5L651.5,15.6L651.5,15.6z M658.6,18.2v3.4h-2.2l-0.3,1.7h-3.6l3.2-12.1
	h2.9v3.7h0.9l1,3.9h-1.1l-0.1-0.6H658.6L658.6,18.2z M667.2,21.4l-2.5,1.9v0.1h-0.1l-6,4.5v-6.3h2.2l0.3,1.7h3.5l0.1-0.1l-3.2-12.1
	h-2.9v-0.9h8.6C667.2,10.3,667.2,21.4,667.2,21.4z"
      />
      <rect x="658.7" y="17.3" className="st0" width="0" height="1" />
      <path
        className="st0"
        d="M658.6,14.9L658.6,14.9L658.6,14.9z M658.7,16.1L658.7,16.1V15l0,0V16.1z"
      />
      <polygon className="st0" points="664.6,23.4 664.7,23.4 664.7,23.3 " />
      <polygon
        className="st0"
        points="659.2,17.3 658.9,16.1 658.7,16.1 658.7,17.3 658.9,17.3 "
      />
      <rect x="658.6" y="16.1" className="st0" width="0" height="1.2" />
      <rect x="658.6" y="16.1" className="st0" width="0" height="1.2" />
      <rect x="658.7" y="16.1" className="st0" width="0" height="1.2" />
      <polygon
        className="st0"
        points="658.4,17.3 658,17.3 658.4,16.1 658.6,16.1 658.6,14.9 658.6,14.9 657.7,14.9 656.7,18.8 657.8,18.8 
	657.9,18.2 658.6,18.2 658.6,18.2 658.6,17.3 "
      />
      <path
        className="st0"
        d="M664.7,8.6h3.5V5.1h-3.5v2.6H663V5.1h-3.5v2.6h-1.7V5.1h-3.5v2.6h-1.7V5.1h-3.5v3.5H664.7L664.7,8.6z
	 M666.2,6.4l0.3-0.8l0.3,0.8h0.9L666.9,7l0.3,0.9l-0.7-0.5L665.8,8l0.2-1l-0.7-0.6H666.2L666.2,6.4z M660.9,6.5l0.3-0.8l0.3,0.8h0.9
	l-0.7,0.6L662,8l-0.7-0.5l-0.7,0.6l0.3-0.9L660,6.5H660.9L660.9,6.5z M655.7,6.4l0.3-0.8l0.3,0.8h0.9L656.5,7l0.3,0.9L656,7.3
	l-0.7,0.6l0.3-0.9l-0.7-0.6H655.7L655.7,6.4z M650.8,7.3l-0.7,0.6l0.3-0.9l-0.7-0.6h0.9l0.3-0.8l0.3,0.8h0.9L651.3,7l0.3,0.9
	L650.8,7.3L650.8,7.3z"
      />
      <polygon
        className="st0"
        points="10.2,14.9 10.2,16.1 10.2,17.3 10.2,18.2 10.2,18.2 "
      />
      <polygon
        className="st0"
        points="10.2,18.2 10.2,18.2 10.2,21.7 10.2,21.7 "
      />
      <polygon
        className="st0"
        points="10.2,11.2 10.2,14.9 10.2,14.9 10.2,14.9 "
      />
      <path
        className="st0"
        d="M10.2,18.2L10.2,18.2v-1l0,0V18.2z M10.2,16.1v1.2V16.1z M10.2,16.1L10.2,16.1V15l0,0V16.1z"
      />
      <rect x="10.2" y="14.9" className="st0" width="0" height="1.1" />
      <rect x="10.2" y="17.3" className="st0" width="0" height="1" />
      <polygon
        className="st0"
        points="15.8,15.6 16.5,15 17.2,15.5 17,14.7 17.7,14.1 16.8,14.1 16.5,13.3 16.2,14.1 15.3,14.1 16,14.7 "
      />
      <path
        className="st0"
        d="M20.5,13.1v-2.6h-0.7V9.4H0.7v1.1H0v2.6h0.7v4.3H0V20h0.7v1.8l3.7,2.9L4,25.2l2,1.6l0.4-0.6l3.7,2.9l0,0l0,0
	l3.8-2.9l0.4,0.6l2.1-1.6L16,24.6l3.7-2.8V20h0.7v-2.6h-0.7V13L20.5,13.1L20.5,13.1z M3.1,15.6l0.3-0.9l-0.7-0.6h0.9l0.3-0.8
	l0.3,0.8H5l-0.7,0.6l0.3,0.9L3.9,15L3.1,15.6L3.1,15.6z M10.2,18.2v3.4H8l-0.3,1.7H4.1l3.2-12.1h2.9v3.7h0.9l1,3.9H11l-0.1-0.6H10.2
	L10.2,18.2z M18.8,21.4l-2.5,1.9v0.1h-0.1l-6,4.5v-6.3h2.2l0.3,1.7h3.5l0.1-0.1l-3.2-12.1h-2.9v-0.9h8.6V21.4L18.8,21.4z"
      />
      <rect x="10.3" y="17.3" className="st0" width="0" height="1" />
      <path
        className="st0"
        d="M10.2,14.9L10.2,14.9L10.2,14.9z M10.3,16.1L10.3,16.1V15l0,0V16.1z"
      />
      <polygon className="st0" points="16.2,23.4 16.3,23.4 16.3,23.3 " />
      <polygon
        className="st0"
        points="10.8,17.3 10.5,16.1 10.3,16.1 10.3,17.3 10.5,17.3 "
      />
      <rect x="10.2" y="16.1" className="st0" width="0" height="1.2" />
      <rect x="10.2" y="16.1" className="st0" width="0" height="1.2" />
      <rect x="10.3" y="16.1" className="st0" width="0" height="1.2" />
      <polygon
        className="st0"
        points="10,17.3 9.6,17.3 10,16.1 10.2,16.1 10.2,14.9 10.2,14.9 9.3,14.9 8.3,18.8 9.4,18.8 9.5,18.2 
	10.2,18.2 10.2,18.2 10.2,17.3 "
      />
      <path
        className="st0"
        d="M16.3,8.6h3.5V5.1h-3.5v2.6h-1.7V5.1h-3.5v2.6H9.4V5.1H5.9v2.6H4.2V5.1H0.7v3.5H16.3L16.3,8.6z M17.8,6.4
	L18,5.6l0.3,0.8h0.9L18.5,7l0.3,0.9L18,7.3l-0.7,0.6L17.6,7l-0.7-0.6H17.8L17.8,6.4z M12.5,6.5l0.3-0.8l0.3,0.8H14l-0.7,0.6L13.6,8
	l-0.7-0.5l-0.7,0.6L12.4,7l-0.7-0.6L12.5,6.5L12.5,6.5z M7.3,6.4l0.3-0.8l0.3,0.8h0.9L8.1,7l0.3,0.9L7.6,7.3L6.9,7.9L7.2,7L6.4,6.4
	H7.3L7.3,6.4z M2.4,7.3L1.7,7.9L2,7L1.2,6.4h0.9l0.3-0.8l0.3,0.8h0.9L2.9,7l0.3,0.9L2.4,7.3L2.4,7.3z"
      />
      <g className="st1">
        <path
          className="st0"
          d="M66.2,23H51.1l-3,5.7h-4.4L56.5,5.1H61l12.7,23.6h-4.4L66.2,23z M64.5,19.5L58.7,8.6l-5.8,10.9H64.5z"
        />
      </g>
      <g className="st1">
        <path className="st0" d="M97.3,25.5v3.2H78.1V7.6h3.6v17.9H97.3z" />
        <path
          className="st0"
          d="M123.8,14.5c0,4.4-3.4,6.9-8.5,6.9h-10.6v7.3h-3.6V7.6h14.2C120.4,7.6,123.8,10.1,123.8,14.5z M120.1,14.5
		c0-2.7-2-3.8-5.1-3.8h-10.3v7.5H115C118.1,18.3,120.1,17.2,120.1,14.5z"
        />
        <path className="st0" d="M128.1,28.6V7.6h3.6v21.1H128.1z" />
        <path
          className="st0"
          d="M161.2,7.6v21.1H158L141.6,12v16.6h-3.5V7.6h3.9l15.8,16v-16H161.2z"
        />
        <path
          className="st0"
          d="M188.6,25.5v3.2h-21V7.6h20.7v3.2h-17.1v5.6h14.4v3.2h-14.4v6H188.6z"
        />
      </g>
      <g className="st1">
        <path
          className="st0"
          d="M226.6,23h-15.1l-3,5.7h-4.4l12.8-23.6h4.4l12.7,23.6h-4.4L226.6,23z M224.8,19.5l-5.8-10.9l-5.8,10.9H224.8z"
        />
      </g>
      <g className="st1">
        <path
          className="st0"
          d="M257.5,28.6L251,21h-8.9v7.6h-3.6V7.6h14.3c4.9,0,8.5,2.3,8.5,6.7c0,3.6-2.5,5.9-6.2,6.5l6.8,7.8H257.5z
		 M252.6,17.9c3,0,5.1-1,5.1-3.6c0-2.6-2-3.6-5.1-3.6h-10.5v7.2H252.6z"
        />
        <path
          className="st0"
          d="M293.8,7.6v21.1h-3.6V12.5l-10,12.2h-0.2l-10-12.2v16.2h-3.5V7.6h3.9l9.8,12.1l9.8-12.1H293.8z"
        />
        <path
          className="st0"
          d="M298.6,18.1c0-7,5-11.2,13.1-11.2c8.1,0,13.1,4.2,13.1,11.2c0,6.9-5,11.2-13.1,11.2
		C303.6,29.3,298.6,25.1,298.6,18.1z M321.1,18.1c0-5.1-3.7-8-9.4-8c-5.7,0-9.4,2.9-9.4,8c0,5.1,3.7,8,9.4,8
		C317.5,26.1,321.1,23.2,321.1,18.1z"
        />
        <path
          className="st0"
          d="M348.8,28.6l-6.5-7.6h-8.9v7.6h-3.6V7.6h14.3c4.9,0,8.5,2.3,8.5,6.7c0,3.6-2.5,5.9-6.2,6.5l6.8,7.8H348.8z
		 M343.8,17.9c3,0,5.1-1,5.1-3.6c0-2.6-2-3.6-5.1-3.6h-10.5v7.2H343.8z"
        />
        <path className="st0" d="M357.7,28.6V7.6h3.6v21.1H357.7z" />
        <path
          className="st0"
          d="M390.8,7.6v21.1h-3.2L371.1,12v16.6h-3.5V7.6h3.9l15.8,16v-16H390.8z"
        />
        <path
          className="st0"
          d="M420.8,23.9c-1.9,3.1-6.1,5.4-11.9,5.4c-8.3,0-13.3-4.2-13.3-11.2c0-7,5-11.2,13.2-11.2
		c5.2,0,8.7,1.9,10.8,4.2l-2.9,2.1c-1.9-2.1-4.3-3.1-7.9-3.1c-5.9,0-9.6,2.7-9.6,8c0,5.3,3.7,8,9.7,8c3.7,0,6.7-1,8.2-3.4v-2.4h-8.8
		v-3.1h12.3V23.9z"
        />
      </g>
      <g className="st1">
        <path
          className="st0"
          d="M462.7,28.6l-7.3-8.6h-9.9v8.6h-4V5.1h16c5.5,0,9.5,2.6,9.5,7.5c0,4.1-2.8,6.6-6.9,7.3l7.6,8.8H462.7z
		 M457.2,16.6c3.4,0,5.7-1.1,5.7-4s-2.3-4-5.7-4h-11.8v8H457.2z"
        />
      </g>
      <g className="st1">
        <path
          className="st0"
          d="M494.2,25.5v3.2h-21V7.6h20.7v3.2h-17.1v5.6h14.4v3.2h-14.4v6H494.2z"
        />
        <path
          className="st0"
          d="M522.1,7.6v21.1h-3.2L502.4,12v16.6h-3.5V7.6h3.9l15.8,16v-16H522.1z"
        />
      </g>
      <g className="st1">
        <path
          className="st0"
          d="M550.2,10.7h-9.6v17.9H537V10.7h-9.5V7.6h22.7V10.7z"
        />
      </g>
      <g className="st1">
        <path
          className="st0"
          d="M568.6,23.6h-13.5l-2.7,5.1h-3.9l11.4-21.1h4l11.4,21.1h-3.9L568.6,23.6z M567,20.5l-5.1-9.7l-5.1,9.7H567z"
        />
      </g>
      <g className="st1">
        <path className="st0" d="M598.7,25.5v3.2h-19.1V7.6h3.6v17.9H598.7z" />
      </g>
      <g className="st1">
        <path
          className="st0"
          d="M624.8,22.4c0,4-3.9,6.9-11.1,6.9c-4.9,0-9.3-1.4-12.6-4.3l2.3-2.6c2.9,2.6,6.2,3.7,10.5,3.7
		c4.7,0,7.3-1.2,7.3-3.4c0-2.2-2.6-2.7-7.9-3.2c-5.8-0.5-11.3-1.8-11.3-6.1c0-4.2,4.8-6.5,10.9-6.5c4.6,0,8.5,1.4,11,3.5l-2.3,2.5
		c-2.2-1.9-5.1-2.8-8.6-2.8c-3.3,0-7.3,0.8-7.3,3.1c0,2.2,3.5,2.6,8.1,3C620.2,16.7,624.8,18,624.8,22.4z"
        />
      </g>
    </svg>
  );
};

export default Logo;
